import { listingQueryKeys as e } from "../listings/useListingSearchQuery.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { roomsApi as r } from "@maat/api-main";
//#region src/rooms/useUnblockRoomDatesMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ roomId: e, ...t }) => r.unblockRoomDates(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.calendars() }), i.invalidateQueries({ queryKey: e.workspaceHostBlocks() });
		}
	});
};
//#endregion
export { i as useUnblockRoomDatesMutation };
